module.exports = __webpack_public_path__ + "static/img/help_06intro_33.c6187c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_06intro_33.png
// module id = 730
// module chunks = 140